const PlannerIcon = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 9H12.25C11.2835 9 10.5 9.7835 10.5 10.75V26.25C10.5 27.2165 11.2835 28 12.25 28H23.75C24.7165 28 25.5 27.2165 25.5 26.25V10.75C25.5 9.7835 24.7165 9 23.75 9H22.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <rect x="13.5" y="7.5" width="9" height="3" rx="1.5" stroke="currentColor" strokeWidth="1.25" />
    <path d="M14 16H22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M14 19.5H22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <path d="M14 23H19" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    <circle cx="23.5" cy="23.5" r="3" fill="currentColor" opacity="0.9" />
    <path d="M22.5 23.5L23.2 24.2L24.5 23" stroke="white" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PlannerIcon;
